export const data = function() {
  return {
    isDebug: true,
    loading: false,
    styles: {
      mainContainer: {
        minHeight: '1000px'
      }
    }
  }
}
